import { Link } from 'react-router-dom';
import { Settings2 } from 'lucide-react';
import type { ConfigError } from '../lib/configError';

/**
 * A calm, actionable notice for an external-token/config problem — not a
 * red-alarm error. Explains what's wrong, names the exact permission the GitHub
 * token needs, and links to Settings to fix it.
 */
export function ConfigErrorNotice({ error }: { error: ConfigError }) {
  return (
    <div className="card flex flex-col gap-3 border-warning-500/30 bg-warning-500/15 p-4">
      <div className="flex items-start gap-3">
        <Settings2
          className="mt-0.5 h-5 w-5 shrink-0 text-warning"
          aria-hidden="true"
        />
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-medium text-ink">
            GitHub configuration needed
          </p>
          <p className="text-sm text-ink-muted">{error.message}</p>
          {error.permission && (
            <p className="text-xs text-ink-muted">
              Required permission:{' '}
              <span className="font-medium text-ink-muted">
                {error.permission}
              </span>
            </p>
          )}
        </div>
      </div>
      <div>
        <Link
          to="/settings"
          className="inline-flex items-center gap-1.5 rounded-lg border border-warning-500/40 bg-warning-500/10 px-3 py-1.5 text-sm font-medium text-warning-200 hover:bg-warning-500/20"
        >
          Update GitHub token in Settings
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  );
}
